export const widgetName = 'ValidatedValueSelection';
export const manualInputsWidgetType = 'ManualInputs';
export const spotManualInputsWidgetType = 'SpotManualInputs';

export const specialWidgetTypes = [widgetName, manualInputsWidgetType, spotManualInputsWidgetType];